// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__12dZ9","fileBtn":"File_fileBtn__kWke5","closeBtn":"File_closeBtn__1JYnR","fileSelected":"File_fileSelected__1Cug0","disabled":"File_disabled__1CLTh"};